import { IP } from 'entities/ip';
import { Client } from 'services/apiGatewayClient';
import { createService } from 'services/genericAPIGatewayService';
import { State } from 'store';
import { mapMpsWhitelistedIPResponseToEntity } from '../adapters';
import { MpsWhitelistedIPResponse } from '../types';
import { Service } from './services';

const client = new Client<IP, IP, MpsWhitelistedIPResponse, MpsWhitelistedIPResponse[]>({
  mapToRequest: (x: IP) => x,
  mapFromResponse: mapMpsWhitelistedIPResponseToEntity,
  mapFromListResponse: (data: MpsWhitelistedIPResponse[]) =>
    Array.isArray(data) ? data.map(mapMpsWhitelistedIPResponseToEntity) : [],
});

const endpointCreator = (state: State) => '/mps/global-whitelisted-ips';

export const { Actions, Selectors, Sagas } = createService<IP, Service.GlobalIpWhitelist>({
  service: Service.GlobalIpWhitelist,
  client,
  endpointCreator,
  stateConverter: (state: State) => state.campaigns.globalIpWhitelist,
  sagas: ['GET_COLLECTION'],
});
